import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { addFormData, fetchAllDashboardDataAPI } from '../../utils/api';

const TopCustomer = () => {
    const centerid = localStorage.getItem('centerdata');
    const [topcustomer, setTopCustomer] = useState([])

    useEffect(() => {
        getTopAgent(centerid)
    }, [centerid])

    const getTopAgent = (centerid) => {
        fetchAllDashboardDataAPI('center-get-top-customer-dashboard-data', centerid).then((resp) => {
            if (resp.data.status === 1) {
                setTopCustomer(...[resp.data.topcustomer])
            }
        })
    }
    const handleInputs = e => {
        const data = { valuetype: e.target.value, centerid: centerid }
        addFormData('center-get-top-customer-date-dashboard-data', data).then((resp) => {
            if (resp.data.status === 1) {
                setTopCustomer(...[resp.data.topcustomer])
            }
        })
    }
    return (
        <div className="topagentproduct card radius-10 overflow-hidden w-100">
            <div className="card-header border-bottom bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="headingtitle">
                        <h6>Top 15 Customer</h6>
                    </div>
                    <div className="select">
                        <Form.Select
                            placeholder="Member Type"
                            name="top_customer"
                            className="topagentselect"
                            onChange={handleInputs}
                        >
                            <option value="Today">Today</option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="Week">Week</option>
                            <option value="Month">Month</option>
                        </Form.Select>
                    </div>
                </div>
            </div>
            <div className="topagentproductsection">
                {topcustomer?.map((topcustomer, index) => (
                    <div className="agentbody" key={index}>
                        <span className="name">{topcustomer?.order_name}</span>
                        <span className="name">{topcustomer?.total_count}</span>
                    </div>
                ))}

            </div>
        </div>
    )
}

export default TopCustomer